package com.evoapps.evoshift.ui.reports

import kotlinx.browser.document
import org.w3c.dom.HTMLIFrameElement

/** Prints from a hidden frame, so the app page itself is not printed and no pop-up is needed. */
actual fun printHtml(title: String, html: String) {
    document.getElementById(FRAME_ID)?.remove()
    val frame = document.createElement("iframe") as HTMLIFrameElement
    frame.id = FRAME_ID
    frame.setAttribute("style", "position:fixed;right:0;bottom:0;width:0;height:0;border:0;")
    frame.title = title
    document.body?.appendChild(frame)
    val doc = frame.contentDocument ?: return
    doc.open()
    doc.write(html)
    doc.close()
    frame.onload = null
    // Give the frame a moment to lay out before printing.
    kotlinx.browser.window.setTimeout({
        frame.contentWindow?.focus()
        frame.contentWindow?.print()
    }, 250)
}

private const val FRAME_ID = "evoshift-print-frame"
